import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchProject, fetchFinancialAssetCategoriesByBusinessUnit, addProjectFinancialAssetCategory } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function ProjectFinancialAssetCategoryAddPage() {
  const { businessDomainId, businessUnitId, projectId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const basePath = `/strategy/${businessDomainId}/business-units/${businessUnitId}/projects/${projectId}`;

  const [available, setAvailable] = useState([]);
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const [project, all] = await Promise.all([fetchProject(projectId), fetchFinancialAssetCategoriesByBusinessUnit(businessUnitId)]);
        const assigned = new Set((project.associatedFinancialAssetCategories || []).map((c) => c.financialAssetCategoryId));
        setAvailable((Array.isArray(all) ? all : []).filter((c) => !assigned.has(c.financialAssetCategoryId)));
      } catch (e) { notify.apiError(e); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, businessUnitId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedId) { notify.error(t("common.selectRequired")); return; }
    try {
      await addProjectFinancialAssetCategory(projectId, selectedId);
      notify.success(t("message.create.success"));
      navigate(`${basePath}/financial-asset-categories`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("project.financialAssetCategory.add.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <FormControl fullWidth required>
              <InputLabel>{t("financialAssetCategory.name")}</InputLabel>
              <Select value={selectedId} onChange={(e) => setSelectedId(e.target.value)} label={t("financialAssetCategory.name")}>
                {available.map((c) => (
                  <MenuItem key={c.financialAssetCategoryId} value={c.financialAssetCategoryId}>{c.financialAssetCategoryName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.add")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/business-units/${businessUnitId}/projects/${projectId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
